var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.708 16.291a1 1 0 00-1.414 0L13 20.585V1a1 1 0 10-2 0v19.585l-4.293-4.294a1 1 0 00-1.414 1.414l5.999 6.001a1.001 1.001 0 001.416 0l5.999-6.001a.999.999 0 000-1.414",
    fill: "#222",
    fillRule: "nonzero",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconArrowDown;